import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { toastify, toastType } from "util/toastify";

import api from "../../api";
import { Checkbox } from "antd";
import PortfolioImageUploadOnSignUp from "view/component/portfolioImageUploadOnSignUp";
import CertificationImageUploadOnSignUp from "view/component/certificationImageUploadOnSignUp";

const AddService = () => {
  const [service, setService] = useState({});
  const [portfolioList, setPortfolioList] = useState([]);
  const [certificationList, setCertificationList] = useState([]);
  console.log('service', service)
  console.log('portfolioList', portfolioList)
  console.log('certificationList', certificationList)
  const rateRef = useRef(null);

  const history = useHistory();

  const changeUploadPortfolio = (requireWorkSamples) => {
    let tmp = { ...service }
    tmp.requireWorkSamples = !!requireWorkSamples
    setService(tmp)
  }
  const changeUploadCertificate = (requireCertifications) => {
    let tmp = { ...service }
    tmp.requireCertifications = !!requireCertifications
    setService(tmp)
  }

  const changeRate = (rate) => {
    let tmp = { ...service };
    tmp.rate = rate;
    setService(tmp);
    if (rateRef.current) {
      rateRef.current.value = rate;
    }
  };


  const changeTitle = (title) => {
    let tmp = service;
    tmp.title = title;
    setService(tmp);
  };

  const changeDesc = (detail) => {
    let tmp = service;
    tmp.detail = detail;
    setService(tmp);
  };

  const changeExp = (detail) => {
    let tmp = service;
    tmp.experience = detail;
    setService(tmp);
  };

  const changeType = (detail) => {
    let tmp = service;
    tmp.type = detail;
    setService(tmp);
  };

  const saveHandler = () => {
    if (!service.title?.trim()) {
      return toastify("Please Input Service Title.", toastType.error);
    }
    if (!service.rate) {
      return toastify("Input Correct Rate For Service.", toastType.error);
    }
    if (!service.type) {
      return toastify("Please select service type.", toastType.error);
    }
    if (!service.experience?.trim()) {
      return toastify("Input experience about your service.", toastType.error);
    }
    if (!service.detail?.trim()) {
      return toastify("Input detail about your service.", toastType.error);
    }

    let newObj = {
      ...service,
      servicePortfolios: portfolioList,
      serviceCertifications: certificationList
    }

    api
      .post(`/api/service/new/`, newObj)
      .then(() => {
        toastify("New Service Added.", toastType.success);
        history.push("/my-profile");
      })
      .catch((err) => {
        console.error(err);
        toastify("Adding New Service Failed.", toastType.error);
      })
  }

  return (
    <main className="flex-1 edit-service mb-16">
      <div className="container justify-center">
        <div className="edit-panel w-full max-w-[800px] bg-[#f9f9f9] py-10 px-5 sm:px-10 md:px-20 rounded-[20px]">
          <h2 className="text-center">Your Service</h2>
          <p className="text-center mt-[24px] mb-[52px]">
            Please enter your details for the services
          </p>
          <form>
            <h3 className="ml-2 mb-2">Service Title</h3>
            <input
              type="text"
              name="service_title"
              placeholder="Enter here"
              onChange={(e) => changeTitle(e.target.value)}
              className="w-full h-[50px] mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
              required
            />
            <h3 className="ml-2 mb-2">What Experience You Have</h3>
            <textarea
              type="text"
              name="field"
              placeholder="Enter here"
              onChange={(e) => changeExp(e.target.value)}
              className="w-full h-36 mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
              required
            />
            <h3 className="ml-2 mb-2">What Will Receiver Get</h3>
            <textarea
              type="text"
              name="field"
              placeholder="Enter here"
              onChange={(e) => changeDesc(e.target.value)}
              className="w-full h-36 mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
              required
            />
            <h3 className="ml-2 mb-2">Select your service type.</h3>
            <div className="ml-2 mb-4 flex items-center text-lg">
              <input
                type="radio"
                name="type"
                className="mr-1"
                value="virtual"
                onClick={(e) => changeType(e.target.value)}
                checked={service.type}
              />
              <span className="mr-8">Virtual</span>
              <input
                type="radio"
                name="type"
                className="mr-1"
                value="in-person"
                onClick={(e) => changeType(e.target.value)}
              />
              <span className="mr-8">In Person</span>
              <input
                type="radio"
                name="type"
                className="mr-1"
                value="both"
                onClick={(e) => changeType(e.target.value)}
              />
              <span>Both</span>
            </div>

            <h3 className="ml-2 mb-2">Points Rate for Service</h3>
            <div className="relative">
              <input
                type="number"
                name="points_rate"
                min={0}
                ref={rateRef}
                value={service.rate || ""}
                onChange={(e) => changeRate(e.target.value)}
                className="w-full h-12 mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-xl no-spinner"
                style={{
                  MozAppearance: "textfield",
                }}
                placeholder="Select a rate"
                readOnly

              />

              <div className="flex absolute top-1.5 right-2">
                {[5, 10, 15, 20].map((val) => (
                  <button
                    key={val}
                    type="button"
                    onClick={() => changeRate(String(val))}
                    className={`px-4 sm:px-5 py-2 mr-2.5 border border-solid rounded-full cursor-pointer transition-colors
        ${Number(service.rate) === val
                        ? "bg-[#1CC300] text-white border-[#1CC300]"
                        : "bg-transparent text-[#1CC300] border-[#1CC300] hover:bg-[#1CC300]/10"
                      }`}
                  >
                    {val}
                  </button>
                ))}
              </div>

            </div>


            <div className="flex mb-4">
              <div className="basis-1/2">
                <span>
                  <Checkbox
                    className="mr-1"
                    checked={!!service.requireWorkSamples}
                    onChange={(e) =>
                      changeUploadPortfolio(e.target.checked)
                    }
                  />
                  Add Work Sample
                </span>
              </div>
              <div className="basis-1/2">
                <span>
                  <Checkbox
                    className="mr-1"
                    checked={!!service.requireCertifications}
                    onChange={(e) =>
                      changeUploadCertificate(e.target.checked)
                    }
                  />
                  Add Certifications
                </span>
              </div>
            </div>

            {
              !!service.requireWorkSamples &&
              <PortfolioImageUploadOnSignUp
                items={portfolioList}
                setter={setPortfolioList}
              />
            }
            {
              !!service.requireCertifications &&
              <CertificationImageUploadOnSignUp
                items={certificationList}
                setter={setCertificationList}
              />
            }

            <button
              type="button"
              onClick={() => saveHandler()}
              className="block mx-auto py-2 md:py-3 px-8 md:px-16 mt-[25px] text-white bg-main border-none outline-none rounded-full transition-colors duration-300 hover:bg-[#2bef0a]"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default AddService;
